import { TPaymentOrder } from '@shared/types';
import { getLsConfig } from '@shared/legacy_compat/nextjs/lsconfig/getLsConfig';
import _ from 'lodash';
// @ts-ignore
import Tap from '@tapfiliate/tapfiliate-js';

const debug_log = false;

export const getTapfiliateId = (): string => {
  const { runtimeConfig } = getLsConfig();
  return runtimeConfig?.NEXT_PUBLIC_TAPFILIATE_ID;
};

export const tapfiliateInit = async () => {
  const tapfiliateId = getTapfiliateId();
  if (!_.isNil(tapfiliateId)) {
    if (debug_log) {
      console.log(`Init tapfiliate (${tapfiliateId})...`);
    }
    Tap.init(tapfiliateId);
  }
};

export const tapfiliateConversion = async (paymentOrder: TPaymentOrder) => {
  const tapfiliateId = getTapfiliateId();
  if (!_.isNil(tapfiliateId)) {
    const orderNumber = _.get(paymentOrder, 'DATA.orderNumber', null);
    const amount = _.get(paymentOrder, 'DATA.amount.value', null);
    if (debug_log) {
      console.log(
        `Send conversion for ${orderNumber} (${amount} €) to tapfiliate (${tapfiliateId})...`,
      );
    }
    // Tapfiliate conversion call
    Tap.conversion(orderNumber, amount);
  }
};
